// Single source of truth for EvalPro pricing + promo countdown.
// Keep this in sync with EVALPRO_PRICE_ARS in backend/server.py (el servidor cobra; esto es para mostrar).

export const CURRENT_PRICE_ARS = 39900;
export const PREVIOUS_PRICE_ARS = 49900;

// Pack de entrevistas para profesionales con pocos alumnos. Cada entrevista es
// UNA entrevista inicial; el retest y las pruebas funcionales de esa persona no
// gastan. No vencen. Lo pagado en packs se descuenta del ilimitado.
// Mantener en sync con PACK_PRICE_ARS y PACK_CREDITOS en backend/server.py:
// el precio que se cobra lo calcula SIEMPRE el servidor; esto es para mostrar.
export const PACK_PRICE_ARS = 9900;
export const PACK_ENTREVISTAS = 3;

// Capacitación para gimnasios (B2B), precio de lista desde el 10/10/2026
// (fuente: "Producto - hechos y cifras"). No pasa por el checkout: se cierra
// por WhatsApp y se cobra por transferencia. precio null = a cotizar.
export const GIMNASIO_PRECIOS = [
  { equipo: 'Hasta 5 entrenadores', precio: 110000 },
  { equipo: 'De 6 a 15', precio: 180000 },
  { equipo: '16 o más', precio: null },
];

export const DISCOUNT_PERCENT = Math.round(
  ((PREVIOUS_PRICE_ARS - CURRENT_PRICE_ARS) / PREVIOUS_PRICE_ARS) * 100
);

// Promo countdown: 3 real days, persisted per-visitor in localStorage
// so reloads don't fake-reset. When expired, auto-loop to +3d.
export const COUNTDOWN_DURATION_MS = 3 * 24 * 60 * 60 * 1000;
const COUNTDOWN_STORAGE_KEY = 'evalpro_promo_end';

export function getPromoEndTimestamp() {
  const now = Date.now();
  if (typeof window === 'undefined') return now + COUNTDOWN_DURATION_MS;
  try {
    const raw = window.localStorage.getItem(COUNTDOWN_STORAGE_KEY);
    if (raw) {
      const end = parseInt(raw, 10);
      if (!Number.isNaN(end) && end > now) return end;
    }
    const fresh = now + COUNTDOWN_DURATION_MS;
    window.localStorage.setItem(COUNTDOWN_STORAGE_KEY, String(fresh));
    return fresh;
  } catch {
    return now + COUNTDOWN_DURATION_MS;
  }
}

// Bumps the target to now + 3d. Used when timer hits 0 (loop restart).
export function rotatePromoEndTimestamp() {
  const fresh = Date.now() + COUNTDOWN_DURATION_MS;
  try {
    if (typeof window !== 'undefined') {
      window.localStorage.setItem(COUNTDOWN_STORAGE_KEY, String(fresh));
    }
  } catch { /* noop */ }
  return fresh;
}

// es-AR thousands separator ("$39.900")
export function formatPriceARS(amount) {
  return new Intl.NumberFormat('es-AR', {
    style: 'currency',
    currency: 'ARS',
    maximumFractionDigits: 0,
  }).format(amount);
}
